import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg24UserblockG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M18.458 12a5 5 0 1 1 0 10 5 5 0 0 1 0-10m-6.5-1.2c1.364 0 2.658.297 3.822.83a6 6 0 0 0-1.388.958 7.8 7.8 0 0 0-2.434-.388l-.247.004a7.8 7.8 0 0 0-7.492 6.818l-.029.278h8.725c.21.506.487.976.82 1.4H3.457a.7.7 0 0 1-.7-.71l.004-.255C2.908 14.76 6.98 10.8 11.958 10.8m9.565 4.311-4.954 4.954a3.6 3.6 0 0 0 4.954-4.954M18.458 13.4a3.6 3.6 0 0 0-2.915 5.713l5.028-5.028a3.6 3.6 0 0 0-2.113-.685m-6.5-11.1a3.533 3.533 0 1 1 0 7.067 3.533 3.533 0 0 1 0-7.067m0 1.4a2.133 2.133 0 1 0 0 4.267 2.133 2.133 0 0 0 0-4.267"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24UserblockG$1 = Svg24UserblockG;

export { Svg24UserblockG$1 as default };
